import { faFileInvoiceDollar, faFileSlash, faHourglassClock, faList } from '@fortawesome/pro-regular-svg-icons'
import { BasicTable } from 'src/components/era-package'
import { STATEMENT_TYPE } from '../../shared'
import { SummaryTotal } from './SummaryTotal'

const totals = {
  key: 'summaryTotal', title: 'Summary Totals',
  icon: faFileInvoiceDollar,
  Component: SummaryTotal
}
const historySection = {
  key: 'entrySummaryDeletedHist', title: 'Entry Summary Deleted',
  icon: faFileSlash,
  Component: BasicTable,
  rowAction: [
    STATEMENT_TYPE.entry,
    rowData => ([rowData.dailyStatement, rowData.entryNumber])
  ]
}
const updateSection = (key) => ({
  key, title: (key.startsWith('pms')
    ? 'Periodic Monthly' : 'Daily')
    + ' Statement Update History',
  icon: faHourglassClock,
  Component: BasicTable,
  rowAction: [
    STATEMENT_TYPE.entry,
    rowData => ([rowData.statementNumber, rowData.relatedEntryNumber])
  ]
})

export const getSections = (type, finalized) => {
  switch (type) {
    case STATEMENT_TYPE.daily:
    case STATEMENT_TYPE.dailyPeriodic:
      return [
        totals,
        {
          key: 'entryList', title: 'Entry List',
          icon: faList,
          Component: BasicTable,
          rowAction: [STATEMENT_TYPE.entry, 'entryNumber']
        },
        finalized
          ? historySection
          : updateSection('dailyStatementUpdateHist')
      ]
    case STATEMENT_TYPE.monthly:
      return [
        totals,
        {
          key: 'pdsList', title: 'Periodic Daily Statement List',
          icon: faList,
          Component: BasicTable,
          rowAction: [STATEMENT_TYPE.pmsDaily, 'statementNumber']
        },
        finalized
          ? historySection
          : updateSection('pmsUpdateHist')
      ]
    default:
      return [totals]
  }
}